import { AppRegistry } from 'react-native'

import App from 'app/src/App'

AppRegistry.registerComponent('NovsysReact', () => App)
AppRegistry.runApplication('NovsysReact', {
  rootTag: document.getElementById('root'),
})
